const pickDefined = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
  
  /**
   * NB: le thunk updateMedicalInfo convertit en FormData si `avatar` est un File.
   */
  export default function mapMedicalUpdatePayload(values = {}, current = {}) {
    const safeCurrent = current ?? {};
  
    return pickDefined({
      tailleCm:       values.tailleCm       ?? safeCurrent.tailleCm,
      poidsKg:        values.poidsKg        ?? safeCurrent.poidsKg,
      groupeSanguin:  values.groupeSanguin  ?? safeCurrent.groupeSanguin,
      avatar:         values.avatar instanceof File ? values.avatar : undefined,
      adresse:        values.adresse        ?? safeCurrent.adresse,
    });
  }
  

  